/**
 * Slow editorial marquee — one long string looping horizontally.
 */
export default function Marquee({ words = [], className = "" }) {
  const line = words.join(" · ");
  return (
    <div className={`relative overflow-hidden py-8 border-y border-[#e4e4e7] ${className}`}>
      <div className="flex whitespace-nowrap marquee-track will-change-transform">
        {Array.from({ length: 6 }).map((_, i) => (
          <span
            key={i}
            className="font-editorial italic text-[clamp(3rem,8vw,7rem)] leading-none px-8 text-[#d4d4d8]"
          >
            {line} ·
          </span>
        ))}
      </div>
    </div>
  );
}
